module.exports = __webpack_public_path__ + "static/img/0023.0cf3a5cf.png";